import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import CommonFooter from "../../../core/common/footer/commonFooter";
import Table from "../../../core/pagination/datatable";
import { API_BASE_URL } from "../Config/Config";
import { Button, Popover, Spin } from "antd";
import axios from "axios";
import { CopyOutlined } from "@ant-design/icons";
import RefreshIcon from "../../../core/common/tooltip-content/refresh";

const Jobs = () => {
  const [Jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    SuperId: "",
    ProcessUrl: "",
    StartTime: "",
    EndTime: "",
    Interval: "",
    TimeOutSec: "",
    DeviceId: "",
    Notes: "",
  });

  const columns = [
    {
      title: "SuperId",
      dataIndex: "SuperId",
      sorter: (a, b) => (a?.SuperId || 0) - (b?.SuperId || 0),
    },
    // {
    //   title: "ProcessUrl",
    //   dataIndex: "ProcessUrl",
    //   render: (text) => (
    //     <span title={text}>
    //       {text?.length > 20 ? text.substring(0, 20) + "..." : text}
    //     </span>
    //   ),
    // },
    {
      title: "ProcessUrl",
      dataIndex: "ProcessUrl",
      align: "center",
      render: (text) => {
        if (!text) return null;

        const content = (
          <div
            style={{
              maxWidth: 250,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              gap: 8,
            }}
          >
            <div style={{ wordBreak: "break-word" }}>{text}</div>

            <Button
              size="small"
              icon={<CopyOutlined />}
              onClick={() => navigator.clipboard.writeText(text)}
            >
              Copy
            </Button>
          </div>
        );

        return (
          <div
            style={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <Popover
              content={content}
              trigger={["hover", "click"]}
              placement="top"
            >
              <span style={{ cursor: "pointer" }}>
                <i className="fa-solid fa-link"></i>
              </span>
            </Popover>
          </div>
        );
      },
    },
    {
      title: "StartTime",
      dataIndex: "StartTime",
      sorter: (a, b) => {
        const getMinutes = (t) => {
          if (!t) return 0;

          let [time, modifier] = t.split(" ");
          let [hours, minutes, seconds] = time.split(":");

          hours = parseInt(hours, 10);
          minutes = parseInt(minutes, 10);
          seconds = parseInt(seconds || 0, 10);

          // handle AM/PM safely
          if (modifier === "PM" && hours < 12) hours += 12;
          if (modifier === "AM" && hours === 12) hours = 0;

          return hours * 3600 + minutes * 60 + seconds;
        };

        return getMinutes(a?.StartTime) - getMinutes(b?.StartTime);
      },
    },
    {
      title: "EndTime",
      dataIndex: "EndTime",
      sorter: (a, b) => {
        const getMinutes = (t) => {
          if (!t) return 0;

          let [time, modifier] = t.split(" ");
          let [hours, minutes, seconds] = time.split(":");

          hours = parseInt(hours, 10);
          minutes = parseInt(minutes, 10);
          seconds = parseInt(seconds || 0, 10);

          if (modifier === "PM" && hours < 12) hours += 12;
          if (modifier === "AM" && hours === 12) hours = 0;

          return hours * 3600 + minutes * 60 + seconds;
        };

        return getMinutes(a?.EndTime) - getMinutes(b?.EndTime);
      },
    },
    {
      title: "Interval",
      dataIndex: "Interval",
      sorter: (a, b) => (a?.Interval || 0) - (b?.Interval || 0),
    },
    {
      title: "Time",
      dataIndex: "TimeOutSec",
      sorter: (a, b) => (a?.TimeOutSec || 0) - (b?.TimeOutSec || 0),
    },
    {
      title: "DC Id",
      dataIndex: "DeviceId",
    },
    {
      title: "Notes",
      dataIndex: "Notes",
      align: "center",
      render: (text) => {
        if (!text) return null;

        const content = (
          <div
            style={{
              maxWidth: 250,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              gap: 8,
            }}
          >
            <div style={{ wordBreak: "break-word" }}>{text}</div>
          </div>
        );

        return (
          <div
            style={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <Popover
              content={content}
              trigger={["hover", "click"]}
              placement="top"
            >
              <span style={{ cursor: "pointer" }}>
                <i className="fa-solid fa-message"></i>{" "}
              </span>
            </Popover>
          </div>
        );
      },
    },
    {
      title: "Actions",
      render: (_, record) => (
        <div className="action-icon d-inline-flex align-items-center">
          <Link
            to="#"
            className="p-2 d-flex align-items-center border rounded me-2"
            data-bs-toggle="modal"
            data-bs-target="#edit_sms_user"
            onClick={() => handleEdit(record)}
          >
            <i className="ti ti-edit" />
          </Link>

          <Link
            title="Run"
            to="#"
            className="me-2 p-2 d-flex align-items-center border rounded"
            onClick={() => {
              if (record.ProcessUrl) {
                window.open(record.ProcessUrl, "_blank", "noopener,noreferrer");
              } else {
                alert("URL not available");
              }
            }}
          >
            <i className="ti ti-player-play" />
          </Link>
        </div>
      ),
    },
  ];

  const getallorgkeygeneration = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/api/getjobslisting`);
      const data = response.data?.ResultData || [];
      setJobs(data);
    } catch (error) {
      console.error("Error fetching inactive organizations:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getallorgkeygeneration();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle Add Job Submission
  const handleAddJob = async (e) => {
    setLoading(true);
    e.preventDefault();

    // Basic validation
    if (
      !formData.SuperId ||
      !formData.ProcessUrl ||
      !formData.StartTime ||
      !formData.EndTime ||
      !formData.Interval ||
      !formData.TimeOutSec ||
      !formData.DeviceId
    ) {
      Swal.fire(
        "Validation Error",
        "Please fill all required fields",
        "warning",
      );
      return;
    }

    const payload = {
      SuperId: formData.SuperId.toString(),
      ProcessUrl: formData.ProcessUrl,
      StartTime: formData.StartTime,
      EndTime: formData.EndTime,
      Interval: formData.Interval,
      TimeOutSec: formData.TimeOutSec,
      Notes: formData.Notes || "No notes",
      DeviceId: formData.DeviceId,
    };

    try {
      const response = await axios.post(`${API_BASE_URL}/api/addjob`, payload);

      if (
        response.data.Status === true &&
        response.data.ResultData[0]?.Status === "1"
      ) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Job added successfully!",
          timer: 2000,
          showConfirmButton: true,
          confirmButtonText: "OK",
        });

        // Close modal & reset form
        document.querySelector("#add_plans .btn-close")?.click();
        setFormData({
          SuperId: "",
          ProcessUrl: "",
          StartTime: "",
          EndTime: "",
          Interval: "",
          TimeOutSec: "",
          DeviceId: "",
          Notes: "",
        });

        getallorgkeygeneration();
      } else {
        throw new Error(
          response.data.ResultData[0]?.ResultMessage || "Unknown error",
        );
      }
    } catch (error) {
      console.error("Error adding job:", error);
    } finally {
      setLoading(false);
    }
  };

  const [addLoading, setAddLoading] = useState(false);
  const [editJobForm, setEditJobForm] = useState({
    ProcessUrl: "",
    Interval: "",
    Id: "",
  });

  const [selectId, setSelectId] = useState();
  const handleEdit = (record) => {
    console.log("Editing SMS User:", record);
    setSelectId(String(record.SuperId));
    setEditJobForm({
      //   SuperId: String(record.SuperId || ""),
      Id: String(record.Id || ""),
      ProcessUrl: String(record.ProcessUrl || ""),
      Interval: String(record.Interval || ""),
    });
  };

  const handleEditJobChange = (e) => {
    setEditJobForm({
      ...editJobForm,
      [e.target.name]: e.target.value,
    });
  };

  const updateJob = async () => {
    setAddLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/jobedit`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(editJobForm),
      });

      const data = await response.json();

      if (data.ResultData[0].Status === "1") {
        Swal.fire("Updated!", "Jobs Updated", "success");
        document.getElementById("closeModel").click();
        getallorgkeygeneration();
      } else {
        Swal.fire("Error", data.ResultMessage, "error");
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong", "error");
    }
    setAddLoading(false);
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <>
      {addLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(255,255,255,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <Spin size="large" />
        </div>
      )}

      {/* Page Wrapper */}

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Jobs Listing</h4>
                <h6>Manage your Jobs</h6>
              </div>
            </div>
            <ul className="table-top-head">
              {/* <li>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Refresh"
                >
                  <i data-feather="rotate-ccw" className="feather-rotate-ccw" />
                </Link>
              </li> */}
               <li onClick={handleRefresh} style={{ cursor: "pointer" }}>
                <RefreshIcon />
              </li>
              <li>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Collapse"
                  id="collapse-header"
                >
                  <i data-feather="chevron-up" className="feather-chevron-up" />
                </Link>
              </li>
            </ul>
            <div className="page-btn">
              <Link
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#add_plans"
                className="btn btn-primary"
              >
                <i className="ti ti-circle-plus me-1"></i>
                Add
              </Link>
            </div>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3 ">
              <h5 className="mb-3">Jobs List</h5>
              <div className="search-set"></div>

              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"></div>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <Table columns={columns} dataSource={Jobs}  />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
      {/* /Page Wrapper */}
      <div className="modal fade" id="add_plans">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Job</h4>
              <button
                type="button"
                className="btn-close custom-btn-close p-0"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <form onSubmit={handleAddJob}>
              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label">
                      SuperId <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      name="SuperId"
                      className="form-control"
                      value={formData.SuperId}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">
                      Process URL <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="ProcessUrl"
                      className="form-control"
                      value={formData.ProcessUrl}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">
                      Start Time <span className="text-danger">*</span>
                    </label>
                    <input
                      type="time"
                      name="StartTime"
                      className="form-control"
                      value={formData.StartTime}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">
                      End Time <span className="text-danger">*</span>
                    </label>
                    <input
                      type="time"
                      name="EndTime"
                      className="form-control"
                      value={formData.EndTime}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">
                      Interval (minutes) <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      name="Interval"
                      className="form-control"
                      value={formData.Interval}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">
                      Timeout (seconds) <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      name="TimeOutSec"
                      className="form-control"
                      value={formData.TimeOutSec}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">
                      Device ID <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      name="DeviceId"
                      className="form-control"
                      value={formData.DeviceId}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Notes</label>
                    <input
                      type="text"
                      name="Notes"
                      className="form-control"
                      value={formData.Notes}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  Save Job
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Edit Model */}

      <div className="modal fade" id="edit_sms_user">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Edit Jobs</h4>
              <button
                id="closeModel"
                type="button"
                className="btn-close custom-btn-close p-0"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <form>
              <div className="modal-body pb-3">
                <div className="row">
                  {/* Super Id */}
                  <div className="col-md-4">
                    <label className="form-label">Super Id</label>
                    <input
                      type="text"
                      className="form-control"
                      name="SuperId"
                      value={selectId || ""}
                      disabled
                    />
                  </div>

                  {/* API URL */}
                  <div className="col-md-4">
                    <label className="form-label">ProcessUrl</label>
                    <input
                      type="text"
                      className="form-control"
                      name="ProcessUrl"
                      value={editJobForm.ProcessUrl}
                      onChange={handleEditJobChange}
                    />
                  </div>

                  {/* URL */}
                  <div className="col-md-4">
                    <label className="form-label">Interval</label>
                    <input
                      type="text"
                      className="form-control"
                      name="Interval"
                      value={editJobForm.Interval}
                      onChange={handleEditJobChange}
                    />
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={
                    editJobForm.Password !== editJobForm.ConfirmPassword
                  }
                  onClick={updateJob}
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Jobs;
